"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as r } from "react/jsx-runtime";
import { useIsInverseVariant as a } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const i = (_param)=>{
    var { color: t, size: c = 24 } = _param, e = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const l = a(), s = t !== null && t !== void 0 ? t : l ? o.colors.inverse : o.colors.neutralHigh;
    return /* @__PURE__ */ r("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ r("path", {
            fill: s,
            d: "M20.92 6.586c.58.583.924 1.418.921 2.233-.003.818-.325 1.568-.933 2.168-.126.126-.736.675-1.61 1.457v5.271c0 1.23-.347 2.224-1.03 2.953-.73.778-1.763 1.173-3.065 1.173H6.245c-1.306 0-2.334-.395-3.062-1.173-.683-.729-1.028-1.723-1.028-2.953V6.331c0-2.577 1.569-4.176 4.092-4.176h8.956c2.302 0 3.81 1.361 4.044 3.569a3.2 3.2 0 0 1 1.673.862m-2.827 11.13h.003v-4.197l-.002.002a3108 3108 0 0 1-4.611 4.093l-.143.126c-.135.12-.297.213-.468.27l-3.759 1.243a1.34 1.34 0 0 1-1.367-.325 1.33 1.33 0 0 1-.32-1.37L8.688 13.8c.076-.224.208-.423.384-.577 3.423-3.028 7.202-6.38 7.457-6.636.43-.431.96-.708 1.52-.837-.198-1.538-1.187-2.39-2.843-2.39H6.247c-1.862 0-2.887 1.057-2.887 2.972v11.384c0 .916.235 1.63.703 2.13.493.526 1.226.792 2.184.792h8.958c.958 0 1.692-.266 2.185-.793.465-.498.703-1.216.703-2.129m1.97-7.586c.375-.37.574-.824.574-1.314a1.97 1.97 0 0 0-.569-1.375 1.96 1.96 0 0 0-1.367-.569c-.46 0-.93.171-1.328.569-.33.33-5.058 4.518-7.512 6.686l-1.297 3.815a.13.13 0 0 0 .03.135c.034.033.085.044.138.03l3.76-1.243.19-.154c4.44-3.933 7.131-6.334 7.38-6.58"
        })
    }));
}, m = i;
export { m as default };
